import { memo } from 'react'
import { Image, Link, useTheme } from '@homebotapp/hb-react-component-catalog'
import { useSelector } from 'react-redux'
import { Link as ReactRouterLink } from 'react-router-dom'
import {
  selectCompanyName,
  selectCompanyBrandDarkLogoUri,
  selectCompanyBrandLightLogoUri
} from '../../../store/selectors/customerProfile'
import { useDigestUrl } from '../../../hooks/navigation/useDigestUrl'

export const BrandLogo = () => {
  const { theme } = useTheme()

  const homeownerOrBuyerDigestUrl = useDigestUrl()

  const companyName = useSelector(selectCompanyName)
  const darkBrandLogo = useSelector(selectCompanyBrandDarkLogoUri)
  const lightBrandLogo = useSelector(selectCompanyBrandLightLogoUri)
  const isLight = theme.isLightThemeType
  const source = isLight ? lightBrandLogo : darkBrandLogo

  return (
    <Link as={ReactRouterLink} to={homeownerOrBuyerDigestUrl}>
      <MemoedImage source={source} alt={companyName} />
    </Link>
  )
}

type MemoedImageProps = {
  source: string
  alt: string
}

const MemoedImage = memo(({ source, alt }: MemoedImageProps) => {
  return <Image height='auto' width='auto' maxHeight={8} maxWidth={48} src={source} alt={alt} />
})
